import store from "src/Reducers/store";
import * as appActions from "src/Actions/appActions";

const setCurrentPage = (pageIndex: number) =>
  store.dispatch(appActions.setCurrentPage(pageIndex));

const LIST_DATA_INTRO_TEMPLATE = [
  {
    icon: "gearWithCircuits",
    iconColor: "white",
    text: "Drastically reduce under & over \nutilization of techs",
    listItemCustomStyle: { width: "423.5px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "chip",
    iconColor: "white",
    text: "Create Optimized Service Areas \nusing Historical Jobs, Tech and \nGeo-Spatial information with the \nkey objective to improve the jobs \ncompletion rate",
    listItemCustomStyle: { width: "423.5px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_INTRO_TO = {
  styleLeftPanel: { paddingRight: 0 },
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "topaz.png",
  title: "TURF OPTIMIZATION",
  text: "Turfing, or Service Area, sets logical boundaries in Telecom Field Operations, \nencompassing one or more Wire Centers. Technicians from garages within \nthe same Turf handle all local jobs. Originally for organization, Turfs became \nrigid, limiting adaptability and optimal routing potential. Our AI/ML solution \nprovides dynamic turfing based on business dynamics.",
  listData: LIST_DATA_INTRO_TEMPLATE,
  styleListData: { marginTop: "50px" },
  next: {
    label: "FIND OUT HOW",
    onClick: () => setCurrentPage(402),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(1),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "TURF_OPTIMIZATION/TO_bg_1.png",
};
